import React from 'react';
import PropTypes from 'prop-types';
import Banner from './Banner';

export const PLAYBOOK_HEADER =
    'Re-open confidently with Eventbrite’s COVID-19 Safety Playbook';

const PlaybookBanner = (props) => {
    const trackingData = {
        type: 'TRACK_PLAYBOOK_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'PLAYBOOKBannerClick',
                category: props.category,
            },
        },
    };

    const destinationURL = 'https://www.eventbrite.com/l/covid19-event-safety/';

    return (
        <Banner leftAccentColor="#F05537" style="dark" header={PLAYBOOK_HEADER}>
            <span>
                We partnered with risk management and health experts to empower
                event creators to thoughtfully consider potential safety and
                security risks at your event.{' '}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    See the playbook
                </a>
                .
            </span>
        </Banner>
    );
};

PlaybookBanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default PlaybookBanner;
